export class DownloadMisureINModel {
  idProgetto: number
}